/// <reference types="vite/client" />

import type { QueryClient } from "@tanstack/react-query";
import {
	HeadContent,
	Outlet,
	Scripts,
	createRootRouteWithContext,
} from "@tanstack/react-router";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { FavApple, Favicon, Favicon16, Favicon32 } from "@onesolution/assets";
import { ProvidersWrapper } from "@onesolution/components";
import { useLanguage } from "@onesolution/hooks";
import stylesheet from "../styles/app.css?url";

type RouterContext = {
	queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
	head: () => ({
		meta: [
			{
				charSet: "utf-8",
			},
			{
				name: "viewport",
				content: "width=device-width, initial-scale=1",
			},
			{
				title: "One Solution",
			},
		],
		links: [
			{
				href: stylesheet,
				rel: "stylesheet",
			},
			{
				rel: "apple-touch-icon",
				sizes: "180x180",
				href: FavApple,
			},
			{
				rel: "icon",
				type: "image/png",
				sizes: "32x32",
				href: Favicon32,
			},
			{
				rel: "icon",
				type: "image/png",
				sizes: "16x16",
				href: Favicon16,
			},
			{ rel: "icon", href: Favicon },
			{
				href: "https://fonts.googleapis.com",
				rel: "preconnect",
			},
			{
				href: "https://fonts.gstatic.com",
				rel: "preconnect",
				crossOrigin: "anonymous",
			},
			{
				href: "https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400..900&display=swap",
				rel: "stylesheet",
			},
			{
				href: "https://cdn01.boxcdn.net/platform/elements/23.0.0/en-US/explorer.css",
				rel: "stylesheet",
			},
			{
				href: "https://cdn01.boxcdn.net/platform/elements/23.0.0/en-US/sidebar.css",
				rel: "stylesheet",
			},
		],
	}),
	scripts: () => [
		{
			src: "https://cdn01.boxcdn.net/platform/elements/23.0.0/en-US/explorer.js",
		},
		{
			src: "https://cdn01.boxcdn.net/platform/elements/23.0.0/en-US/sidebar.js",
		},
	],
	// TODO -> create dedicated pages for error and not found | Duplicate with router?
	errorComponent: () => <p>Error</p>,
	notFoundComponent: () => <p>Not Found</p>,
	component: RootDocument,
});

function RootDocument() {
	const { locale } = useLanguage();
	return (
		<html lang={locale?.split("-")[0]} suppressHydrationWarning>
			<head>
				<HeadContent />
			</head>
			<body className="relative h-dvh w-dvw m-0 p-0 overflow-hidden">
				<ProvidersWrapper>
					<Outlet />
				</ProvidersWrapper>

				<TanStackRouterDevtools />
				<ReactQueryDevtools />
				<Scripts />
			</body>
		</html>
	);
}
